<template>
  <i-select :value="value" @on-change="update" :filterable="filterable" :multiple="multiple">
    <i-option value="IDPs (Stock)">IDPs (Stock)</i-option>
    <i-option value="New Displacement (Flow)">New Displacement (Flow)</i-option>
    <i-option value="Returnees (Stock)">Returnees (Stock)</i-option>
    <i-option value="Locally Integrated IDPs (Stock)">Locally Integrated IDPs (Stock)</i-option>
    <i-option value="IDPs Settled Elsewhere (Stock)">IDPs Settled Elsewhere (Stock)</i-option>
    <i-option
      value="People Displaced Across Borders (Stock)"
    >People Displaced Across Borders (Stock)</i-option>
    <i-option value="Multiple Displacement (Flow)">Multiple Displacement (Flow)</i-option>
    <i-option value="Births (Flow)">Births (Flow)</i-option>
    <i-option value="Deaths (Flow)">Deaths (Flow)</i-option>
    <i-option value="Return (Flow)">Return (Flow)</i-option>
    <i-option
      value="Failed Return / Returnee Displacement (Flow)"
    >Failed Return / Returnee Displacement (Flow)</i-option>
    <i-option value="Local Integration (Flow)">Local Integration (Flow)</i-option>
    <i-option value="Failed Local Integration (Flow)">Failed Local Integration (Flow)</i-option>
    <i-option value="Relocation Elsewhere (Flow)">Relocation Elsewhere (Flow)</i-option>
    <i-option value="Failed Relocation Elsewhere (Flow)">Failed Relocation Elsewhere (Flow)</i-option>
    <i-option value="Cross-border Flight (Flow)">Cross-border Flight (Flow)</i-option>
    <i-option value="Cross-border Return (Flow)">Cross-border Return (Flow)</i-option>
    <i-option value="Provisional Solutions (Flow)">Provisional Solutions (Flow)</i-option>
    <i-option value="Partial (Flow)">Partial (Flow)</i-option>
    <i-option value="Partial (Stock)">Partial (Stock)</i-option>
    <i-option value="Unverified (Flow)">Unverified (Flow)</i-option>
    <i-option value="Unverified (Stock)">Unverified (Stock)</i-option>
  </i-select>
</template>

<script>
export default {
  name: "FactTypeSelect",
  props: ["value", "filterable", "multiple"],
  methods: {
    update(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style>
</style>
